import { combineReducers } from 'redux'
import modal from './modal'
import sidebar from './sidebar'
import auth from './auth'
import user from './user'
import content from './content'
import customer from './customer'
import customContentType from './custom-content-type'
import responsible from './responsible'
import inspection from './inspection'
import statics from './statics'
import periodicCheck from './periodic-check'
import company from './company'
import element from './element'
import license from './license'
import contact from './contact'
import notification from './notification'
import enargas from './enargas'
import previewPdf from './preview-pdf'
import invitation from './invitation'
import supportTasks from './support-tasks'

const createRootReducer = () =>
  combineReducers({
    authStore: auth,
    companyStore: company,
    contactStore: contact,
    contentStore: content,
    customerStore: customer,
    customContentTypeStore: customContentType,
    elementStore: element,
    inspectionStore: inspection,
    licenseStore: license,
    modalStore: modal,
    notificationStore: notification,
    periodicCheckStore: periodicCheck,
    responsibleStore: responsible,
    sidebarStore: sidebar,
    staticsStore: statics,
    userStore: user,
    previewPdfStore: previewPdf,
    enargasStore: enargas,
    invitationStore: invitation,
    supportTasksStore: supportTasks
  })

export default createRootReducer
